import Vue from 'vue'
import App from './App.vue'
import router from './routers/router'
// import VCharts from 'v-charts'
// 有赞Vant UI
// import Vant from 'vant'
// 验证
import Validator from 'validator'
// vant css
// import 'vant/lib/index.css'
// 模拟进度条
import 'nprogress/nprogress.css'
// rem基准设置
import 'lib-flexible/flexible'
// 自定义工具类
import '@/style/reset.css'
import '@/style/style.scss'
import '@/utils/wxconfig'
import VueClipboard from 'vue-clipboard2'
// jquery
// import jquery from 'jquery'

// 全局组件
import publicHeader from '@/components/public-header'
import publicFooter from '@/components/public-footer'
import publicFootAudio from '@/components/public-foot-audio'
import publicAudio from '@/components/public-audio'
import publicAudio2 from '@/components/public-audio2'
import publicPop from '@/components/public-pop'
import publicMobile from '@/components/public-mobile'
import publicEwm from '@/components/public-ewm'
import publicTop from '@/components/public-top'
import publicCard from '@/components/public-card'
import publicSpell from '@/components/course/public-spell'
import publicDialogue from '@/components/course/public-dialogue'



// 全局加载vant
// Vue.use(Vant);
// Vue.use(VCharts);

// 全局加载clipboard2
Vue.use(VueClipboard)

// 全局注册组件
Vue.component('public-header', publicHeader);
Vue.component('public-footer', publicFooter);
Vue.component('public-foot-audio', publicFootAudio);
Vue.component('public-audio', publicAudio);
Vue.component('public-audio2', publicAudio2);
Vue.component('public-pop', publicPop);
Vue.component('public-mobile', publicMobile);
Vue.component('public-ewm', publicEwm);
Vue.component('public-top', publicTop);
Vue.component('public-card', publicCard);
Vue.component('public-spell', publicSpell);
Vue.component('public-dialogue', publicDialogue);

Vue.config.productionTip = false;
Vue.prototype.$Validator = Validator;
// 抢购支付请求接口域名（移动端官网）
Vue.prototype.$Url = 'https://www.xjy.cn/';
// Vue.prototype.$jQuery = jquery;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
